<template>
  <v-container fluid class="currency-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
              <v-btn to="/currency/add" color="success" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              v-model="item_seleted"
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="currencies-table"
              show-select
              single-select
              item-key="_id"
              sort-by="createdAt"
              sort-desc
              :footer-props="footer"
              :headers="currencyHeaders"
              :items="currencies"
              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="isDeleteCurrency"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Currency?
                    </v-card-title>
                    <v-card-text>
                      {{ delete_currency.currencyname }}
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="isDeleteCurrency = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteCurrency(delete_currency)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.currencystatus="{ item }">
                <v-chip
                  :color="!item.currencystatus ? 'primaryConst white--text' : 'secondaryConst white--text'"
                  small>
                  {{ item.currencystatus }}
                </v-chip>
              </template>
              <template v-slot:item.lists="{ item }">
                {{ item.lists.length }}
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.updatedAt="{ item }">
                {{ new Date(item.updatedAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="editCurrency(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="deleteCurrencyDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'CurrencyList',
  data() {
    return {
      isDeleteCurrency: false,
      isLoading: false,
      delete_currency: {},
      item_seleted: [],
      currencyHeaders: [
        { text: 'Code', value: 'currencycode'},
        { text: 'Name', value: 'currencyname'},
        { text: 'Type', value: 'currencytype'},
        { text: 'Create', value: 'createdAt' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      footer: {'items-per-page-options': [500, 1000, 5000]},
      itemPerPage: 500,
    }
  },
  computed: {
    ...mapState('Currency', ['currencies', 'isReceiving', 'isDeleting', 'idToDelete', 'isUpdating']),
  },
  async created () {
    await this.getCurrenciesRequest()
  },
  methods: {
    ...mapActions('Currency', ["deleteCurrencyRequest","getCurrenciesRequest"]),
    editCurrency(item) {
      this.$router.push({name: 'CurrencyEdit', params: item});
    },
    deleteCurrency(item) {
      this.deleteCurrencyRequest({_id: item._id});
      this.isDeleteCurrency = false;
    },
    deleteCurrencyDialog(item) {
      this.isDeleteCurrency = true;
      this.delete_currency = {_id: item._id,currencyname: item.currencyname};
    },
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
